var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEnRomanh = function SvgEnRomanh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 632.99 632.99"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "en-romanh_svg__b",
    x1: 262.23,
    x2: 364.72,
    y1: 176.25,
    y2: 337.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#c82523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#bd2221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#a11a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e1618"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "en-romanh_svg__c",
    x1: 265.85,
    x2: 284.61,
    y1: 363.37,
    y2: 157.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ac1f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ce2928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#d42e2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#e53d34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef453a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "en-romanh_svg__a",
    x1: 354.17,
    x2: 370.93,
    y1: 254.28,
    y2: 280.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5a36a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#f4a068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#f19765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed8960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#en-romanh_svg__a",
    id: "en-romanh_svg__d",
    x1: 310.84,
    x2: 327.59,
    y1: 254.27,
    y2: 280.63
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#en-romanh_svg__a",
    id: "en-romanh_svg__e",
    x1: 267.86,
    x2: 284.62,
    y1: 254.27,
    y2: 280.63
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M361.04 201.14a9.354 9.354 0 0 1-5.58-6.54h-.01s-.01-.04-.01-.06c-3.04-10.03 10.46-33.05 10.84-33.7h.01s-18.44-1.97-33.44 17.58l-15.59-30.6-15.61 30.6c-10.27-16.85-33.42-17.59-33.42-17.59s.01.04.02.05c.74 1.26 13.84 23.79 10.82 33.67 0 .02 0 .03-.01.05-.11.47-.25.94-.45 1.38-.04.12-.09.23-.15.36-.19.46-.44.89-.72 1.31-.12.18-.25.37-.39.54l-.03.03c-.11.16-.24.32-.39.47a5.462 5.462 0 0 1-.39.42c-.34.33-.68.63-1.07.9-.1.08-.2.15-.31.21-.13.1-.27.18-.42.26-.18.11-.37.22-.56.31-.23.13-.48.24-.72.35-31.44 12.89-52.98 39.25-52.98 69.66 0 43.13 43.32 78.11 96.76 78.11 1.34 0 2.65-.02 3.98-.08v22.19s44.5-24.54 68.35-46.56c15.82-14.59 21.19-30.86 23.01-40.17.96-4.37 1.43-8.89 1.43-13.48 0-30.41-21.54-56.77-52.97-69.66Zm-84.8 50.7c8.63 0 15.62 7 15.62 15.62s-6.99 15.61-15.62 15.61-15.61-6.99-15.61-15.61 6.99-15.62 15.61-15.62Zm42.97 31.22c-8.62 0-15.61-6.99-15.61-15.61s6.99-15.62 15.61-15.62 15.62 7 15.62 15.62-7 15.61-15.62 15.61Zm43.34 0c-8.62 0-15.62-6.99-15.62-15.61s7-15.62 15.62-15.62 15.61 7 15.61 15.62-6.99 15.61-15.61 15.61Z",
    style: {
      fill: "url(#en-romanh_svg__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.22 348.83c-1.32.06-2.63.08-3.98.08-53.43 0-96.76-34.98-96.76-78.11 0-30.41 21.55-56.77 52.98-69.66.24-.1.49-.21.72-.35.19-.08.38-.19.56-.31.14-.08.28-.17.42-.26.1-.06.2-.13.31-.21.39-.27.73-.58 1.07-.9.11-.11.22-.23.34-.36.02-.02.04-.04.05-.06.14-.15.27-.31.39-.47l.03-.03c.13-.17.26-.36.39-.54.28-.42.53-.85.72-1.31.06-.12.11-.23.15-.36.19-.45.34-.92.45-1.38.01-.02.01-.03.01-.05 3.02-9.87-10.08-32.4-10.82-33.67a.076.076 0 0 1-.02-.04s23.15.73 33.42 17.58l15.61-30.6v26.2c0 20.77-12.85 39.5-32.37 46.61-20.93 7.63-38.76 28.87-41.99 48.01-4.12 34.04 21.39 73.35 78.33 80.18Z",
    style: {
      fill: "url(#en-romanh_svg__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.16 267.46c0 8.62-6.99 15.61-15.61 15.61s-15.62-6.99-15.62-15.61 7-15.62 15.62-15.62 15.61 6.99 15.61 15.62Z",
    style: {
      fill: "url(#en-romanh_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.83 267.46c0 8.62-7 15.61-15.62 15.61s-15.61-6.99-15.61-15.61 6.98-15.62 15.61-15.62 15.62 6.99 15.62 15.62Z",
    style: {
      fill: "url(#en-romanh_svg__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.85 267.46c0 8.62-6.99 15.61-15.62 15.61s-15.61-6.99-15.61-15.61 6.99-15.62 15.61-15.62 15.62 6.99 15.62 15.62Z",
    style: {
      fill: "url(#en-romanh_svg__e)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.33 483.86H150.4l-18.06-30.03h-8.27v30.03h-17.84v-71.93l21-4.57c3.05-.58 5.89-.96 8.54-1.14 2.65-.18 5.35-.24 8.11-.16 3.63.15 7.18 1.41 10.66 3.81 3.48 2.4 6.06 5.51 7.73 9.36 1.67 3.77 2.47 7.29 2.39 10.55 0 10.66-5.19 17.48-15.56 20.46l20.24 33.62Zm-26.44-43.85c2.97-1.88 4.46-4.93 4.46-9.14 0-2.25-.49-4.33-1.47-6.25s-2.3-3.46-3.97-4.62c-1.67-.07-3.19-.06-4.57.05-1.38.11-3.01.34-4.9.71l-8.38 2.07v19.47h9.03c4.13 0 7.4-.76 9.79-2.29ZM176.4 476.35c-1.16-3.04-2.21-6.56-3.16-10.55-.94-3.99-1.41-7.47-1.41-10.45 0-5.88 1.31-11.06 3.92-15.56s6.24-8 10.88-10.5c4.64-2.5 9.97-3.75 16-3.75s11.15 1.23 15.83 3.7 8.33 5.95 10.94 10.45c2.61 4.5 3.92 9.68 3.92 15.56s-1.38 11.19-4.13 15.72c-2.76 4.54-6.47 8.04-11.15 10.5-4.68 2.47-9.92 3.7-15.72 3.7-4.86.07-9.58-.75-14.15-2.45-4.57-1.7-8.49-3.83-11.75-6.37Zm39.5-21.11c0-3.48-.58-6.51-1.74-9.09-1.16-2.57-2.76-4.55-4.79-5.93-2.03-1.38-4.28-2.07-6.75-2.07-2.97 0-5.48.66-7.51 1.96-2.03 1.31-3.55 3.17-4.57 5.6-1.02 2.43-1.52 5.53-1.52 9.3 0 1.09.05 2.32.16 3.7.11 1.38.27 2.76.49 4.13.14 1.31.34 2.54.6 3.7.25 1.16.49 2.18.71 3.04 1.67.94 3.52 1.69 5.55 2.23 2.03.55 3.99.78 5.88.71 2.61 0 4.95-.72 7.02-2.18 2.07-1.45 3.66-3.48 4.79-6.09 1.12-2.61 1.69-5.62 1.69-9.03ZM329.5 430.43c.51 1.89.94 4.19 1.31 6.91.36 2.72.54 5.64.54 8.76v37.76h-16.76l-.44-42c-.73-.58-1.85-1.07-3.37-1.47-1.52-.4-3.26-.67-5.22-.81-1.89 0-3.63.42-5.22 1.25-1.6.84-2.88 2.07-3.86 3.7-.98 1.63-1.47 3.5-1.47 5.61v33.73h-16.65v-34.06c0-2.47-.44-4.48-1.31-6.04-.87-1.56-2.14-2.69-3.81-3.38s-3.81-.96-6.42-.81l-8.05 5.33-.11 38.96h-16.87V429.9l15.12-3.16-.11 13.71h.87l9.9-14.8c6.02 0 10.61.25 13.76.76 3.16.51 5.66 1.47 7.51 2.88 1.85 1.41 3.46 3.61 4.84 6.58 2.18-3.33 4.9-5.89 8.16-7.67 3.26-1.78 6.93-2.67 10.99-2.67 2.25 0 4.88.47 7.89 1.41s5.93 2.1 8.76 3.48ZM369.98 425.65c4.71 0 8.81.87 12.3 2.61 3.48 1.74 6.17 4.28 8.05 7.61 1.88 3.34 2.83 7.33 2.83 11.97v36.02h-9.14c-1.89 0-3.41-.6-4.57-1.8-1.16-1.2-1.74-2.74-1.74-4.62l-.11-3.38h-.55l-3.37 6.31c-1.31 1.23-2.94 2.2-4.9 2.88a29.06 29.06 0 0 1-5.98 1.42c-2.03.25-3.88.34-5.55.27-4.21-.29-8.34-1.27-12.4-2.94a49.35 49.35 0 0 1-2.61-6.91c-.73-2.43-1.09-4.55-1.09-6.37 0-3.77 1.21-6.97 3.65-9.58 2.43-2.61 5.79-4.59 10.07-5.93 4.28-1.34 9.17-2.01 14.69-2.01h7.62v-2.18c0-3.26-.87-5.82-2.61-7.67-1.74-1.85-4.24-2.92-7.51-3.21-3.41-.29-7.33.26-11.75 1.63-1.38.44-2.25.84-2.61 1.2l-9.14-7.62.22-1.63c3.12-1.96 7.05-3.48 11.8-4.57a59.86 59.86 0 0 1 14.42-1.52Zm7.18 34.27h-7.62c-3.77 0-6.75.58-8.92 1.74-2.17 1.16-3.26 3.08-3.26 5.77 0 1.31.29 3.04.87 5.22.15 0 .29.04.44.11.15.07.29.15.44.22.65.22 1.43.44 2.34.65.91.22 1.83.37 2.77.44 2.68.29 5.11.09 7.29-.6 2.18-.69 4.06-1.98 5.66-3.86v-9.68ZM458.55 430.98c.94 7.11 1.38 13.35 1.31 18.72v34.17h-16.98v-32.32c0-1.96-.18-5.23-.54-9.8-1.96-1.09-3.81-1.8-5.55-2.12-1.74-.33-3.99-.42-6.75-.27l-8.92 5.44.11 39.06h-16.97v-52.12l16.97-5.01v13.39l.76.54 10.77-15.12c4.28-.15 8.03-.04 11.26.32 3.23.37 5.98.96 8.27 1.8 2.29.84 4.37 1.94 6.26 3.32ZM471.17 406.82l16.98-5.01v35.58c1.6-3.55 4.13-6.42 7.62-8.6 3.48-2.18 7.54-3.26 12.19-3.26 1.96 0 4.42.51 7.4 1.52 2.97 1.02 6.02 2.25 9.14 3.7.65 2.18 1.2 4.72 1.63 7.62s.65 5.77.65 8.6v36.89h-16.87l-.11-29.92c0-2.54-.11-6.6-.33-12.19a30.21 30.21 0 0 0-4.9-1.8c-1.74-.47-3.26-.71-4.57-.71-2.25 0-4.28.47-6.09 1.41-1.81.94-3.23 2.36-4.24 4.24-1.02 1.89-1.52 4.21-1.52 6.97v31.99h-16.98v-77.04Z"
  })));
};
export { SvgEnRomanh as ReactComponent };